(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name monthlyFlightTime.controller:MonthlyFlightTimeCtrl
	 *
	 * @description
	 *
	 */
	angular.module('monthlyFlightTime').controller('MonthlyFlightTimeCtrl',
			MonthlyFlightTimeCtrl);

	function MonthlyFlightTimeCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'MonthlyFlightTimeCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
        fromDate : null,
        toDate : null,
				month : null,
				year : null,
				date : new Date(),
				crewType : null,
        isConsiderDateRange:false
			},
			masterList : {
				crewTypeList : [],
				yearList : [],
				monthList : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        isValidDateRange : false,
        validDaysCount:45,
        clickOnConsiderDateRange:function () {
          if(!vm.model.searchCriteria.isConsiderDateRange){
            vm.model.searchCriteria.fromDate='From';
            vm.model.searchCriteria.toDate='To';
          }
        }
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchMonthlyFlightTimeReport(params);
		};

		// search Monthly Flight Time Report
		function searchMonthlyFlightTimeReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'monthly_flight_time_report.rptdesign',
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      console.log(searchParams);
		  if(vm.model.searchCriteria.isConsiderDateRange) {
        setDateValidationFlags();
        if (!vm.model.masterList.toDateFormatInvalid
          && !vm.model.masterList.fromDateFormatInvalid) {
          if (istoDateBeforeFromDate()) {
            vm.model.masterList.fromDateAfterToDate = true;
          } else {
            vm.model.masterList.fromDateAfterToDate = false;
          }
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      }


      if(searchParams.fromDate&&searchParams.toDate) {
        // Split the string into day, month, and year parts
        var dateFromParts = searchParams.fromDate.split("/");
        var dateToParts = searchParams.toDate.split("/");

        // Create a new Date object using the parts
        // Note: Months are 0-based in JavaScript, so we subtract 1 from the month
        var fromDate = new Date(dateFromParts[2], dateFromParts[1] - 1, dateFromParts[0]);
        var toDate = new Date(dateToParts[2], dateToParts[1] - 1, dateToParts[0]);
        toDate.setDate(toDate.getDate() + 1);


        var daysCount = getDaysBetweenDates(fromDate, toDate)
        if (vm.model.masterList.validDaysCount < daysCount) {
          vm.model.masterList.isValidDateRange = true;
        } else {
          vm.model.masterList.isValidDateRange = false;
        }
      }

    };



    function getDaysBetweenDates(date1, date2) {
      // Convert both dates to milliseconds
      const date1Milliseconds = date1.getTime();
      const date2Milliseconds = date2.getTime();

      // Calculate the difference in milliseconds
      const timeDifference = Math.abs(date2Milliseconds - date1Milliseconds);

      // Convert the time difference from milliseconds to days
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      return daysDifference;
    }

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }


		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["year"] = param.year.desc;
			searchParamMap["month"] = param.month.code;
			searchParamMap["monthname"] = moment().month(param.month.code - 1).format('MMMM');
			searchParamMap["crewType"] = param.crewType.crewTypeCode;
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      if(vm.model.searchCriteria.isConsiderDateRange){
        searchParamMap["isConsiderDateRange"] = 'Y';
      }else{
        searchParamMap["isConsiderDateRange"] = 'N';
        var year= param.year.desc;
        //in javascript months are represented 0-11
        var month=param.month.code-1;
        var startDate = new Date(year, month, 1);
        var endDate = new Date(year, month + 1, 0);
        searchParamMap["fromDate"] = formatDate(startDate);
        searchParamMap["toDate"] = formatDate(endDate);

      }

			return searchParamMap;
		}

    function formatDate(date) {
      var day = date.getDate();
      var month = date.getMonth() + 1; // Month is 0-indexed, so we add 1
      var year = date.getFullYear();

      // Pad day and month with leading zeros if needed
      day = day < 10 ? '0' + day : day;
      month = month < 10 ? '0' + month : month;

      return day + '/' + month + '/' + year;
    }

		function isValidSearchParams(params) {

      if(vm.model.searchCriteria.isConsiderDateRange) {
        setDateValidationFlags();
        // if date invalid
        if (vm.model.masterList.toDateFormatInvalid
          || vm.model.masterList.fromDateFormatInvalid) {
          return false;
        } else if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
          return false;
        }
      }

			if (!!vm.model.searchCriteria.crewType
					&& !!vm.model.searchCriteria.crewType.crewTypeCode
					&& !!vm.model.searchCriteria.month
					&& !!vm.model.searchCriteria.month.code
					&& !!vm.model.searchCriteria.year
					&& !!vm.model.searchCriteria.year.code) {
				return true;
			}
			return false;
		}

		(function() {
			// crew type master codes
			CommonMasterData
					.getCrewTypeList(
							function(crewTypeList) {
								vm.model.masterList.crewTypeList = crewTypeList;
							},
							function() {
								console
										.log('Crew Type list retrieval error');
							});
			// year List
			CommonMasterData.getYearList(function(yearList) {
				vm.model.masterList.yearList = yearList;
				var a = moment().format('YYYY');
				vm.model.searchCriteria.year = _.find(yearList, function(year) {
					return year.desc == moment().format('YYYY');
				});
			}, function() {
				console.log('Year List retrieval error');
			});
			// Month List
			CommonMasterData.getMonthList(function(monthsOfYear) {
				vm.model.masterList.monthList = monthsOfYear;
				vm.model.searchCriteria.month = _.find(monthsOfYear, function(
						month) {
					return month.desc === moment().format('MMM');
				});
			}, function() {
				console.log('Month list retrieval error');
			});
		})();
	}
}());
